import img1 from "../img/event/Event01.jpg"
import img2 from "../img/event/Event02.jpg"
import img3 from "../img/event/Event03.jpg"
import img4 from "../img/event/Event04.jpg"
import img5 from "../img/event/Event05.jpg"
import img6 from "../img/event/Event06.jpg"
import img7 from "../img/event/Event07.jpg"
import img8 from "../img/event/Event08.jpg"

const EventData = [
   {
      name: "JULIETTE HAS A GUN POP-UP STORE ",
      imgUrl: img1,
      progress: "< 진행중 >",
      spot: "DDMMYY",
      schedule: "2023.08.03 - 08.29",
      description1:
         "기존의 향수 코드에서 벗어나 도발적이고 자유로운 무드의 프랑스 향수 컬렉션, Juliette has a gun. 각국의 도시를 여행하는 것을 즐기며, 셰익스피어를 사랑하고, 삶은 짧고 즐길 것은 많다고 믿는 자유로운 영혼을 가진 줄리엣!",
      description2:
         "그녀의 위트 있고 유니크한 무드의 매력을 모두 담은 25종의 오 드 퍼퓸을 한국에 선보입니다. 일명 살냄새 향의 NOT A COLLECTION 부터 여름의 즐거움을 알리는 칵테일같은 향수들까지 올 뜨거운 여름에 줄리엣 헤즈 어 건이 찾아옵니다!",
      description3:
         "향수 무료 샘플부터 다양한 구매 사은 혜택까지 LCDC SEOUL 팝업 스토어에 준비되어 있습니다!",
      subData: " • OPEN EVERYDAY 12:00 PM - 19:00 PM",
   },
   {
      name: "READY TO LEAVE",
      imgUrl: img2,
      progress: "< 종료 >",
      spot: "DDMMYY",
      schedule: "2023.07.21 - 07.30",
      description1:
         "반복된 일상에서 벗어나 낯선 곳에서 즐기는 여유로움과 한 여름의 평화로운 일상들을 선사하기 위한 팝업 스토어에 초대합니다.",
      description2:
         "경쾌한 컬러와 가벼운 착용감으로 여행을 떠나온 듯한 일상을 느끼게 해주는 '이지피지'의 선글라스, 매 시즌 다양한 소재와 유니크한 디자인을 선보이는 '빈티지 헐리우드', 작지만 잊혀지지 않는 재미를 선사하는 '하이칙스', 눈부신 일상의 아름다움을 선사하는 '르 아보네'를 비롯한 데일리하지만 특별한 악세서리 '로아주'를 직접 LCDC에서 만나 보세요!",
      description3: "팝업 기간 동안 제안하는 스페셜한 선물도 잊지 마세요!",
      subData: " • OPEN EVERYDAY 11:00 PM - 20:00 PM",
   },
   {
      name: "Norienomoto",
      imgUrl: img3,
      progress: "< 종료 >",
      spot: "DOORS",
      schedule: "2023.07.19 - 07.30",
      description1:
         "그림이 되는 옷, 잡화를 컨셉으로 하는 일본 브랜드 'norienomoto'가 처음으로 한국에서 팝업을 진행합니다. ",
      description2:
         "곡선이 아름다운 대표적인 아이템 'mardi matin'을 비롯해, 아이코닉한 웨이브 손잡이와 다르게 직선적이고 세련된 무드가 특징인 'jeudisoir' 등 여러가지 아이템을 선보입니다. ",
      description3: "*행사 기간 동안 예약상품 무료배송* ",
      subData: " • 11AM - 8PM (MON OFF)",
   },
   {
      name: "PYGMALION",
      imgUrl: img4,
      progress: "< 종료 >",
      spot: "DDMMYY",
      schedule: "2023.07.07 - 07.16",
      description1:
         "PORTRAIT REPORT는 스테레오타입을 초월한, 틀에 갇히지 않은 디자인을 추구합니다. PORTRAIT REPOR는 여성과 남성을 구분짓지 않고 ‘WO,MAN’이라는 하나의 DNA로 재해석합니다.",
      description2:
         "PORTRAIT REPORT의 여덟 번째 컬렉션은 그리스 신화 속 피그말리온의 이야기에서 영감을 받아 탄생했습니다. 자신이 조각한 여인상을 사랑하게 된 피그말리온과 그의 소망대로 결국 인간이 된 아름다운 조각상 갈라테이아.",
      description3:
         "인간으로 변하면서 동시에 부서져 가는 조각상의 모습을 떠올리며 ‘변화와 파괴, 탄생이 공존하는 순간’을 표현하고자 했습니다. 깨진 듯한 텍스쳐와 비정형적인 쉐입은 이러한 과정을 상징적으로 나타내고 있습니다. PORTRAIT REPORT의 새로운 컬렉션을 LCDC SEOUL에서 직접 경험해보세요.",
      subData: " • 12:00 PM - 20:00 PM",
   },
   {
      name: "Hidden beads, 숨은 구슬 찾기",
      imgUrl: img5,
      progress: "< 종료 >",
      spot: "DOORS",
      schedule: "2023.07.05 - 07.15",
      description1:
         "Biz(Beads)-Maker, 더아리움의 오프라인 팝업이 성수 LCDC SEOUL에서 열립니다. 이번 팝업에서는 소소한 일상에 기쁨과 가치를 더해 줄 세상에 단 하나뿐인 공예품들을 발견할 수 있습니다.",
      description2:
         "서울여성공예센터 입주기업 10개사의 공예 브랜드들을 한자리에서 직접 만나볼 수 있는 10일간의 특별한 즐거움, <Hidden beads, 숨은 구슬 찾기>에 여러분을 초대합니다.",
      description3:
         "팝업스토어 곳곳에 숨어 있는 구슬을 찾아 나만의 공예품을 만들어보세요.",
      subData: " • 11AM - 7PM",
   },
   {
      name: "헿: 덕화맨숀 프로젝트",
      imgUrl: img6,
      progress: "< 종료 >",
      spot: "DOORS",
      schedule: "2023.06.20 - 07.02",
      description1:
         "한글로 된 티셔츠도 예쁠 수 있을까? 덕화맨숀 프로젝트는 한글로 된 옷, 모자, 제품을 부끄러움 없이 아무렇지 않게 입었으면 좋다고 생각합니다. ",
      description2:
         "한글로 된 옷을 만들기도 하고, 을지로 재개발로 없어져 가는 글자를 아카이빙 하기도 합니다.  덕화맨숀은 옛 것이 가지는 힘을 믿습니다. 이번 팝업 스토어에는 덕화맨숀 제품들 뿐 아니라 한글로 된 다양한 제품들을 만날 수 있습니다.",
      description3:
         "Event ▶ 방문객 대상 100% 당첨 뽑기 이벤트, 한글 옷 혹은 악세사리 착용시 선물 증정, 10만원 이상 구매 시 포스터 증정",
      subData: " • 12PM - 8PM",
   },
   {
      name: "은하수행 심야버스 900번: 별 비 내리는 태백의 밤으로",
      imgUrl: img7,
      progress: "< 종료 >",
      spot: "DDMMYY",
      schedule: "2023.06.17 - 06.27",
      description1:
         "평균 해발고도 900m, 낮에는 산골짜기 사이로 햇빛이 밤에는 탁 트인 하늘 아래 별 비가 쏟아지는 도시, 강원도 태백시입니다. 탄광도시로 많이 알려진 태백에서 몽골에서와 같은 선명한 은하수를 관측할 수 있다는 사실, 아시나요? ",
      description2:
         "높은 고도와 빛공해가 적은 강원도 태백시에서는 육안으로도 선명한 은하수를 관측할 수 있습니다. 다가오는 6월 17일, 태백의 아름다운 은하수를 눈에만 담기가 아쉬워 성수동 LCDC의 한 공간에 담아보고자 합니다.",
      description3:
         "이번 팝업 스토어에서는 ‘태백 은하수 여행’이라는 주제 아래, 여행 전의 설렘, 은하수 아래에서의 경이로움, 여행 후 이를 추억하는 마음 모두를 담을 수 있도록 공간을 구성하였습니다. 컨츄리시티즌이 소개하는 여름 태백의 은하수 많은 관심과 방문 부탁드립니다. ",
      subData: " • 12:00 PM - 20:00 PM",
   },
   {
      name: "The Ver",
      imgUrl: img8,
      progress: "< 종료 >",
      spot: "DDMMYY",
      schedule: "2023.06.03 - 06.11",
      description1:
         "더베르는 일상의 크고 작은 의미 있는 순간에 함께합니다. 아름다움, 삶의 여유, 사랑하는 이의 목소리와 같이 바쁘다는 이유로 누리지 못했던 가치들을 되새기며 모두와 나누고자 합니다.",
      description2:
         "우리는 자연과 함께하는 삶의 지향점을 대변하고 취향을 제안하며 우리의 고객들이 풍성한 삶을 영위할 수 있기를 바랍니다.",
      description3:
         "⌜Promotion⌟ ▶ 방문객 전원 꽃 선물 증정, 배송비 결제시 무료 꽃다발 배송 이벤트",
      subData: " • 12:00 PM - 20:00 PM",
   },
]

export default EventData
